import React, {useEffect, useState} from 'react';
import {resetPassword} from "../../util/APIUtils";
import {useHistory} from "react-router-dom";
import ChangePassword from "./ChangePassword";
import LoadingIndicator from "../../component/LoadingIndicator";
import {notification} from "antd";
import {showAxiosError} from "../../util/Helpers";

function ResetPassword() {
    let history = useHistory();
    const [isLoading, setLoading] = useState(true)
    const [token, setToken] = useState();
    useEffect(() => {
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let token = params.get('token');
        if (token != null) {
            resetPassword(token).then((response) => {
                if (response.data === "OK") {
                    setLoading(false);
                    setToken(token);
                }
            }).catch(error => {
                showAxiosError(error.response);
                history.push("/login");
            })
        }
    })
    return isLoading === true ? (
        <LoadingIndicator/>
    ) : (
        <ChangePassword token={token}/>
    )
}

export default ResetPassword;


// WEBPACK FOOTER //
// ./src/page/forgotPassword/ResetPassword.js